import { Instance, applySnapshot, flow, types, getSnapshot } from 'mobx-state-tree';
import { getAllPlanLabels } from './apiWrappers/wrappers/usePlanLabels';
import { PlanLabel } from '@7chairs/types';

const PlanLabelModel = types.model('OnboardingLabelModel', {
  id: types.string,
  name: types.string,
});

const SelectedPlanLabelsModel = types.map(PlanLabelModel);

const PlanLabelsStoreModel = types
  .model('PlanLabelsModel', {
    allPlanLabels: types.optional(types.map(types.array(PlanLabelModel)), {}),
    selectedPlanLabels: types.optional(SelectedPlanLabelsModel, {}),
  })
  .actions((self) => ({
    fetchAndSetAllPlanLabels: flow(function* fetchOnboardingLabels() {
      const { data, kind } = yield getAllPlanLabels();

      if (kind === 'ok') {
        applySnapshot(self.allPlanLabels, data.planLabels);
      }
    }),
  }))
  .actions((self) => ({
    toggleSelectedPlanLabel(planLabel: PlanLabel): void {
      if (self.selectedPlanLabels.has(planLabel.id)) {
        self.selectedPlanLabels.delete(planLabel.id);
      } else {
        self.selectedPlanLabels.set(planLabel.id, {
          id: planLabel.id,
          name: planLabel.name,
        });
      }
    },
    clearSelectedPlanLabels(): void {
      self.selectedPlanLabels = SelectedPlanLabelsModel.create();
    },
  }))
  .views((self) => ({
    get selectedPlanLabelsIds(): string[] {
      return self.selectedPlanLabels.size ? Array.from(self.selectedPlanLabels.keys()) : [];
    },
    get selectedPlanLabelsNames(): string[] {
      return self.selectedPlanLabels.size ? Array.from(self.selectedPlanLabels.values()).map((pl) => pl.name) : [];
    },
    get selectedPlanLabelsObject(): Record<string, PlanLabel> {
      return getSnapshot(self.selectedPlanLabels);
    },
  }));

interface PlanLabels extends Instance<typeof PlanLabelsStoreModel> {}

export { PlanLabels, PlanLabelsStoreModel };
